import qs from 'qs'
import instance from '@/helpers/axios'
import moment from 'moment'
import numeral from 'numeral'
import { textTruncate } from "Helpers/helpers";

const state = {
    vos_beginDate: null,
    vos_lastDate: null,
    vos_datasets: [],
    vos_sentiment_v1: [],
    vos_sentiment_v2: [],
    vos_objective_v1: [],
    vos_objective_v2: [],
    //v2
    vos_isLoading: false,
    //vos_sentiment: {},
    vos_sentiment_x_date: {},
    vos_purpose: {},
    vos_purpose_x_date: {},
    vos_table: null,
    vos_total: 0,
    vos_purpose: [],
    vos_channels: [],
    vos_sentiment: [],
    vos_sentiment_average: [],
    vos_sentiment_top_five_table: [],
    vos_purpose_average: [],
    vos_purpose_top_third_table: [],
    vos_purpose_donut: [],
    vos_post_all_country: [],
    vos_post_all_country_stackbar: [],
    vos_country_top_five_table: [],
    vos_engagement_southasia_table: []
}

// getters
const getters = {
    vos_date: state => {
        if (state.vos_beginDate != null) {
            var _start = state.vos_beginDate.split("T");
            var _end = state.vos_lastDate.split("T")
            return { start: _start[0], end: _end[0] }
        } else {
            return { start: state.vos_beginDate, end: state.vos_lastDate }
        }
    },
    vos_isLoading: state => {
        return state.vos_isLoading;
    },
    vos_data_date: state => {
        if (state.vos_beginDate !== null) {
            var _start = state.vos_beginDate.split("T");
            var _end = state.vos_lastDate.split("T")
            return _start[0] + " to " + _end[0];
        } else {
            return "N/A"
        }
    },
    vos_datasets: state => {
        return state.vos_datasets;
    },
    vos_sentiment_average: state => {
        return state.vos_sentiment_average;
    },
    vos_sentiment_v1: state => {
        return state.vos_sentiment_v1;
    },
    vos_sentiment_v2: state => {
        return state.vos_sentiment_v2;
    },
    vos_objective_v1: state => {
        return state.vos_objective_v1;
    },
    vos_objective_v2: state => {
        return state.vos_objective_v2;
    },
    vos_table: state => {
        return state.vos_table;
    },
    vos_sentiment_top_five_table: state => {
        return state.vos_sentiment_top_five_table;
    },
    vos_purpose_top_third_table: state => {
        return state.vos_purpose_top_third_table;
    },
    vos_purpose_donut: state => {
        return state.vos_purpose_donut;
    },
    vos_post_all_country_stackbar: state => {
        return state.vos_post_all_country_stackbar;
    },
    vos_post_all_country: state => {
        return state.vos_post_all_country;
    },
    vos_country_top_five_table: state => {
        return state.vos_country_top_five_table;
    },
    vos_engagement_southasia_table: state => {
        return state.vos_engagement_southasia_table
    }
}

// actions
const actions = {
    // start /v2 actions
    V2getVosDatasets(context, payload) {
        state.vos_isLoading = true;
        var _params = {};
        // calulate _params from main_filters                
        var main_filters = payload.main_filters;
        if (main_filters !== null) {
            if (main_filters.start !== null && main_filters.end !== null) {
                _params.start = new Date(main_filters.start).setUTCHours(0, 0, 0, 0);
                _params.end = new Date(main_filters.end).setUTCHours(23, 59, 59, 999);
            }
            if (main_filters.location_source !== null) {
                _params.location_source = main_filters.location_source;
            }
            if (main_filters.location_destination != null) {
                _params.location_destination = main_filters.location_destination;
            }
        }
        const request = {
            params: qs.parse(_params)
        };
        // query data
        instance.get('v2/market/vos', request)
            .then(response => {
                const {
                    date,
                    vos_sentiment,
                    vos_sentiment_x_date,
                    vos_purpose,
                    vos_purpose_x_date,
                } = response.data;

                state.vos_beginDate = date.start;
                state.vos_lastDate = date.end;
                state.vos_sentiment = vos_sentiment;
                state.vos_sentiment_x_date = vos_sentiment_x_date;
                state.vos_purpose = vos_purpose;
                state.vos_purpose_x_date = vos_purpose_x_date;

                payload.stateDatasets.forEach(function(stateName) {
                    if (stateName == "vos_sentiment_v1") {
                        context.commit("V2onVosSentimentV1", payload);
                    } else if (stateName == "vos_sentiment_v2") {
                        context.commit("V2onVosSentimentV2", payload);
                    } else if (stateName == "vos_objective_v1") {
                        context.commit("V2onVosObjectiveV1", payload);
                    } else if (stateName == "vos_objective_v2") {
                        context.commit("V2onVosObjectiveV2", payload);
                    }
                })
                state.vos_isLoading = false;
            })
            .catch(error => {
                console.log(error.response, "[store/market/vos] syntax errors under instant.get");
            })
    },
    getVosDatasets(context, payload) {
        // share with vos/121 vos/122 [chart/table]
        // console.log("[store/market/vos] getVosDatasets() DEPRECATED - excepted /vos/121, /vos/122");

        const request = {
            params: qs.parse({
                limit: 1,
                sort: "-date"
            })
        };
        instance.get('market/vos', request)
            .then(response => {
                const { rows } = response.data;
                const date = rows.map((item) => { return item.date });

                var _start = moment(new Date(date)).add(-7, 'days');
                var _end = moment(new Date(date));
                var _params = {
                    start: _start.format("YYYY-MM-DD"),
                    end: _end.format("YYYY-MM-DD"),
                    sort: '-date'
                };
                // calulate _params from main_filters                
                var main_filters = payload.main_filters;
                if (main_filters !== null) {
                    if (main_filters.start !== null && main_filters.end !== null) {
                        _start = moment(new Date(main_filters.start));
                        _end = moment(new Date(main_filters.end));
                        _params.start = _start.format("YYYY-MM-DD");
                        _params.end = _end.format("YYYY-MM-DD");
                    }
                    if (main_filters.location_source !== null) {
                        _params.location_source = main_filters.location_source;
                    }
                    if (main_filters.location_destination != null) {
                        _params.location_destination = main_filters.location_destination;
                    }
                }

                // calulate _params from sub_filters
                // vos_purpose, vos_channels, vos_sentiment, q, limit, page, sort
                _params.limit = 5;
                _params.page = 1;
                var sub_filter = payload.sub_filter;
                if (sub_filter !== null) {
                    if (sub_filter.vos_purpose !== null) {
                        _params.vos_purpose = sub_filter.vos_purpose;
                    }
                    if (sub_filter.vos_channels !== null) {
                        _params.vos_channels = sub_filter.vos_channels;
                    }
                    if (sub_filter.vos_sentiment !== null) {
                        _params.vos_sentiment = sub_filter.vos_sentiment;
                    }
                    if (sub_filter.q !== "") {
                        _params.q = sub_filter.q;
                    }
                    if (sub_filter.limit > 0) {
                        _params.limit = sub_filter.limit;
                    }
                    if (sub_filter.page > 0) {
                        _params.page = sub_filter.page;
                    }
                    if (sub_filter.sort != "") {
                        _params.sort = sub_filter.sort;
                    }
                }

                state.vos_beginDate = moment(_start).format("YYYY-MM-DD");
                state.vos_lastDate = moment(_end).format("YYYY-MM-DD");

                const request = {
                    params: qs.parse(_params)
                };
                instance.get('market/vos', request)
                    .then(response => {
                        const { vos_purpose, vos_channels, vos_sentiment, count, rows } = response.data;
                        state.vos_datasets = rows;
                        state.vos_total = count;
                        state.vos_purpose = vos_purpose;
                        state.vos_channels = vos_channels;
                        state.vos_sentiment = vos_sentiment;
                        payload.stateDatasets.forEach(function(stateName) {
                            if (stateName == "vos_table") {
                                context.commit("onVosTable", payload);
                            }
                        })
                    })
                    .catch(error => {
                        console.log(error.response, "[store/market/vos] syntax errors under instant.get");
                    })
            })
            .catch(error => {
                console.log(error.response);
            })
    },
    async getVosSentimentAverageDatasets(context, payload) {
        
        state.vos_isLoading = true;
        
        let _params = {};
        // calulate _params from main_filters
        let main_filters = payload.main_filters;
        if (main_filters !== null) {
            if (main_filters.start !== null && main_filters.end !== null) {
                _params.start = main_filters.start;
                _params.end = main_filters.end;
            }
            if (main_filters.location_source !== null) {
                _params.location_source = main_filters.location_source;
            }
            if (main_filters.location_destination != null) {
                _params.location_destination = main_filters.location_destination;
            }
            if (main_filters.campaign_categories != null) {
                _params.campaign_categories = main_filters.campaign_categories;
            }
        }
        const request = {
            params: qs.parse(_params)
        };
        // query data
        await instance.get('social/sentiment/sentiment_average', request)
            .then(response => {
                const {
                    date,
                    rows
                } = response.data;

                state.vos_beginDate = date.start;
                state.vos_lastDate = date.end;
                state.vos_sentiment = rows;

                payload.stateDatasets.forEach(function(stateName) {
                    if (stateName == "vos_sentiment_average") {
                        context.commit("onVosSentimentAverages", payload);
                    }
                })
                state.vos_isLoading = false;
            }).catch(error => {
                console.log(error.response, "[social/sentiment/sentiment_average] syntax errors under instant.get");
            })
    },
    async getVosSentimentTopFiveDatasets(context, payload) {
        state.vos_isLoading = true;
        
        let _params = {};
        // calulate _params from main_filters                
        let main_filters = payload.main_filters;
        if (main_filters !== null) {
            if (main_filters.start !== null && main_filters.end !== null) {
                _params.start = main_filters.start;
                _params.end = main_filters.end;
            }
            if (main_filters.location_source !== null) {
                _params.location_source = main_filters.location_source;
            }
            if (main_filters.location_destination != null) {
                _params.location_destination = main_filters.location_destination;
            }
            if (typeof main_filters.campaign_categories !=='undefined' && main_filters.campaign_categories != null) {
                _params.campaign_categories = main_filters.campaign_categories;
            }
        }

        const request = {
            params: qs.parse(_params)
        };
        // query data
        await instance.get('social/sentiment/top_five', request)
            .then(response => {
                const {
                    date,
                    rows
                } = response.data;

                // state.vos_beginDate = date.start;
                // state.vos_lastDate = date.end;
                state.vos_sentiment_top_five_table = rows;

                payload.stateDatasets.forEach(function(stateName) {
                    if (stateName == "vos_sentiment_average") {
                        context.commit("onVosSentimentTopFive", payload);
                    }
                })
                state.vos_isLoading = false;
            }).catch(error => {
                console.log(error.response, "[social/sentiment/top_five] syntax errors under instant.get");
            })
    },
    async getVosPurposeAverageDatasets(context, payload) {
        
        state.vos_isLoading = true;
        
        let _params = {};
        // calulate _params from main_filters                
        let main_filters = payload.main_filters;
        if (main_filters !== null) {
            if (main_filters.start !== null && main_filters.end !== null) {
                _params.start = main_filters.start;
                _params.end = main_filters.end;
            }
            if (main_filters.location_source !== null) {
                _params.location_source = main_filters.location_source;
            }
            if (main_filters.location_destination != null) {
                _params.location_destination = main_filters.location_destination;
            }
        }
        const request = {
            params: qs.parse(_params)
        };
        // query data
        await instance.get('social/purpose/purpose_average', request)
            .then(response => {
                const {
                    date,
                    rows
                } = response.data;

                state.vos_beginDate = date.start;
                state.vos_lastDate = date.end;
                state.vos_purpose = rows;

                payload.stateDatasets.forEach(function(stateName) {
                    if (stateName == "vos_objective_v1") {
                        context.commit("onVosPurposeAverages", payload);
                    }
                })
                state.vos_isLoading = false;
            }).catch(error => {
                console.log(error.response, "[social/purpose/purpose_average] syntax errors under instant.get");
            })
    },
    async getVosPurposeTopThirdDatasets(context, payload) {
        state.vos_isLoading = true;
        
        let _params = {};
        // calulate _params from main_filters                
        let main_filters = payload.main_filters;
        if (main_filters !== null) {
            if (main_filters.start !== null && main_filters.end !== null) {
                _params.start = main_filters.start;
                _params.end = main_filters.end;
            }
            if (main_filters.location_source !== null) {
                _params.location_source = main_filters.location_source;
            }
            if (main_filters.location_destination != null) {
                _params.location_destination = main_filters.location_destination;
            }
        }
        const request = {
            params: qs.parse(_params)
        };
        // query data
        await instance.get('social/purpose/top_third', request)
            .then(response => {
                const {
                    date,
                    rows
                } = response.data;

                state.vos_purpose_top_third_table = rows;
                payload.stateDatasets.forEach(function(stateName) {
                    if (stateName == "vos_perpose_average") {
                        context.commit("onVosPurposeTopThird", payload);
                    }
                })
                state.vos_isLoading = false;
            }).catch(error => {
                console.log(error.response, "[socia/purpose/top_third] syntax errors under instant.get");
            })
    },
    async getPostSocialAllCountryDatasets(context, payload) {
        // use for widget no. 58
        state.vos_isLoading = true;
        var _params = {};
        // calulate _params from main_filters          
        var main_filters = payload.main_filters;
        if (main_filters !== null) {
            if (main_filters.start !== null && main_filters.end !== null) {
                _params.start = main_filters.start;
                _params.end = main_filters.end;
            }
            if (main_filters.location_source !== null) {
                _params.location_source = main_filters.location_source;
            }
            if (typeof main_filters.location_source_international !=='undefined' && main_filters.location_source_international != null) {
                _params.location_source = main_filters.location_source_international;
            }
            if (main_filters.location_destination != null) {
                _params.location_destination = main_filters.location_destination;
            }
        }
        const request = {
            params: qs.parse(_params)
        };
        //get data
        await instance.get('social/posts_all_country', request)
            .then(response => {
                const {
                    date,
                    rows
                } = response.data;

                state.vos_beginDate = date.start;
                state.vos_lastDate = date.end;
                state.vos_post_all_country = rows;

                payload.stateDatasets.forEach(function(stateName) {
                    if (stateName == "posts_all_country") {
                        context.commit("onPostSocialAllCountry", payload);
                    }
                });
                state.vos_isLoading = false;
            })
            .catch(error => {
                console.log(error.response, "[social/social_all_country] syntax errors under instant.get");
            })
    },
    async getVosCountryTopFiveDatasets(context, payload) {
        state.vos_isLoading = true;
        
        let _params = {};
        // calulate _params from main_filters                
        let main_filters = payload.main_filters;
        if (main_filters !== null) {
            if (main_filters.start !== null && main_filters.end !== null) {
                _params.start = main_filters.start;
                _params.end = main_filters.end;
            }
            if (main_filters.location_source !== null) {
                _params.location_source = main_filters.location_source;
            }
            if (typeof main_filters.location_source_international !=='undefined' && main_filters.location_source_international != null) {
                _params.location_source = main_filters.location_source_international;
            }
            if (main_filters.location_destination != null) {
                _params.location_destination = main_filters.location_destination;
            }
        }

        const request = {
            params: qs.parse(_params)
        };
        // query data
        await instance.get('social/country/top_five', request)
            .then(response => {
                const {
                    date,
                    rows
                } = response.data;

                // state.vos_beginDate = date.start;
                // state.vos_lastDate = date.end;
                state.vos_country_top_five_table = rows;

                payload.stateDatasets.forEach(function(stateName) {
                    if (stateName == "posts_all_country") {
                        context.commit("onPostSocialCountryTopFive", payload);
                    }
                })
                state.vos_isLoading = false;
            }).catch(error => {
                console.log(error.response, "[social/country/top_five] syntax errors under instant.get");
            })
    },
    getEngagementOfSoutheastAsiaDatasets(context, payload) {
        // use for widget no. 57
        state.vos_isLoading = true;
        state.vos_country_filter = null;

        let _params = {};
        let main_filters = payload.main_filters;

        if (main_filters !== null) {
            if (main_filters.start !== null && main_filters.end !== null) {
                _params.start = main_filters.start;
                _params.end = main_filters.end;
            }
            if (typeof main_filters.location_source_international !=='undefined' && main_filters.location_source_international != null) {
                _params.location_source = main_filters.location_source_international;
            }
            if (main_filters.sentiment != null) {
                _params.sentiment = main_filters.sentiment;
            }
            if (main_filters.channel != null) {
                _params.channel = main_filters.channel;
            }
        }

        if (payload.sub_filter != null) {
            if (payload.sub_filter.page != null) {
                _params.page = parseInt(payload.sub_filter.page);
            }
            if (payload.sub_filter.limit != null) {
                _params.limit = parseInt(payload.sub_filter.limit);
            }
            if (payload.sub_filter.q != null) {
                _params.q = payload.sub_filter.q;
            }
        }

        const request = {
            params: qs.parse(_params)
        };
        instance.get('social/engagement_of_southeast_asia', request)
            .then(response => {
                const { count, rows, date } = response.data;
                state.vos_datasets = rows;
                state.vos_total = count;

                state.vos_beginDate = date.start;
                state.vos_lastDate = date.end;

                payload.stateDatasets.forEach(function(stateName) {
                    if (stateName == "engagement_southeast_asia_table") {
                        context.commit("onEngagementOfSoutheastAsiaTable", payload);
                    }
                });
                state.vos_isLoading = false;
            })
        .catch(error => {
            console.log(error.response, "[social/engagement_of_southeast_asia] syntax errors under instant.get");
        })
    }
}

// mutations
const mutations = {
    // V2onVosSentimentV1(state, payload) {
    //     // --- start dataset doughnut for chart
    //     // items = [{data:0,label:'label'}]
    //     var colors = [];
    //     colors['positive'] = '#3241a6';
    //     colors['neutral'] = '#578e47';
    //     colors['negative'] = '#cf9a41';
    //     var rows = state.vos_sentiment.rows;
    //     var total = 0;
    //     var items = [];
    //     for (var key in colors) {
    //         items.push({ color: colors[key], data: 0, "label": key.toUpperCase() });
    //     }

    //     rows.forEach(function(item, index) {
    //         total += item.sum_vos;
    //     });

    //     rows.forEach(function(item, index) {
    //         var _color = "#e5e5e5";
    //         if (colors[item._id.vos_sentiment] !== undefined) {
    //             _color = colors[item._id.vos_sentiment];
    //         }
    //         var label = item._id.vos_sentiment.toUpperCase();
    //         var _item = { "data": item.sum_vos, "label": label, color: _color };

    //         // sort by user defined - colors array
    //         var _index = 0;
    //         for (var key in colors) {
    //             if (key == item._id.vos_sentiment) {
    //                 items[_index] = _item;
    //             }
    //             _index++;
    //         }
    //     });
    //     // check total
    //     if (total == 0) {
    //         items = [];
    //     }
    //     state.vos_sentiment_v1 = items
    //     // --- end dataset for doughnut chart
    // },
    onVosSentimentAverages(state, payload) {
        // --- start dataset doughnut for chart widget no 123
        var colors = [];
        colors['positive'] = '#3241a6';
        colors['neutral'] = '#578e47';
        colors['negative'] = '#cf9a41';
        var rows = state.vos_sentiment;
        var total = 0;
        var items = [];
        for (var key in colors) {
            items.push({ color: colors[key], data: 0, "label": key.toUpperCase() });
        }

        rows.forEach(function(item, index) {
            total += item.count;
        });

        rows.forEach(function(item, index) {
            var _color = "#e5e5e5";
            if (colors[item.sentiment] !== undefined) {
                _color = colors[item.sentiment];
            }
            var label = item.sentiment.toUpperCase();
            var _item = { "data": item.count, "label": label, color: _color };

            // sort by user defined - colors array
            var _index = 0;
            for (var key in colors) {
                if (key == item.sentiment) {
                    items[_index] = _item;
                }
                _index++;
            }
        });
        // check total
        if (total == 0) {
            items = [];
        }
        state.vos_sentiment_v1 = items
        // --- end dataset for doughnut chart
    },
    onVosSentimentTopFive(state, payload) {
        // --- start dataset table for chart widget no 123
        let rows = state.vos_sentiment_top_five_table;
        state.vos_sentiment_top_five_table = rows;
    },
    onVosPurposeAverages(state, payload) {
        // --- start dataset doughnut for chart widget no 124
        var colors = [];
        colors['general'] = '#3241a6';
        colors['question'] = '#578e47';
        colors['enquiries'] = '#cf9a41';
        colors['admire'] = '#be4141';
        colors['complaint'] = '#7d3b98';

        var rows = state.vos_purpose;
        var total = 0;
        var items = [];
        for (var key in colors) {
            items.push({ color: colors[key], data: 0, "label": key.toUpperCase() });
        }

        rows.forEach(function(item, index) {
            total += item.count;
        });

        rows.forEach(function(item, index) {
            var _color = "#e5e5e5";
            if (colors[item.purpose] !== undefined) {
                _color = colors[item.purpose];
            }
            var label = item.purpose.toUpperCase();
            var _item = { "data": item.count, "label": label, color: _color };

            // sort by user defined - colors array
            var _index = 0;
            for (var key in colors) {
                if (key == item.purpose) {
                    items[_index] = _item;
                }
                _index++;
            }
        });
        // check total
        if (total == 0) {
            items = [];
        }
        state.vos_objective_v1 = items
        // --- end dataset for doughnut chart
    },
    onVosPurposeTopThird(state, payload) {
        // --- start dataset table for chart widget no 124
        let rows = state.vos_purpose_top_third_table;
        state.vos_purpose_top_third_table = rows;
    },
    onPostSocialAllCountry(state, payload) {
        // --- start dataset for stack chart
        let total = 0;
        let colors = [];
        colors['FACEBOOK'] = '#3241a6';
        colors['INSTAGRAM'] = '#578e47';
        colors['TWITTER'] = '#cf9a41';
        colors['WEBBOARD'] = '#be4141';
        colors['WEBSITE'] = '#7d3b98';
        colors['YOUTUBE'] = '#e5e5e5';

        let rows = state.vos_post_all_country;
        let items = [];

        rows.forEach((item, index) => {
            total += item.count;
            let _item = {};
            let _competitor_country = item.country;
            let _competitor_channels = item.channel.toUpperCase();
            let pos = items.map((e) => {
                return e.country;
            }).indexOf(item.country);

            if (pos == -1) {
                _item['country'] = item.country;
                _item['FACEBOOK'] = 0;
                _item['INSTAGRAM'] = 0;
                _item['TWITTER'] = 0;
                _item['WEBBOARD'] = 0;
                _item['WEBSITE'] = 0;
                _item['YOUTUBE'] = 0;
                _item[_competitor_channels] = item.count;
                items.push(_item);
            } else {
                _item = items[pos];
                _item[_competitor_channels] = item.count;
                items[pos] = _item;
            }
        });

        // sort by country desc        
        items.sort(function(a, b) {
            return a.country.localeCompare(b.country);
        });

        // attached colors 
        items.push(colors);

        if (total == 0) {
            items = [];
        }

        state.vos_post_all_country_stackbar = items
        // --- end dataset for stack chart
    },
    V2onVosSentimentV2(state, payload) {
        // --- start dataset for stack chart
        // items = [{label1:0,label2:0,...,date:string}]
        var total = 0;
        var colors = [];
        colors['POSITIVE'] = '#3241a6';
        colors['NEUTRAL'] = '#578e47';
        colors['NEGATIVE'] = '#cf9a41';

        var rows = state.vos_sentiment_x_date.rows;
        var items = [];
        rows.forEach(function(item, index) {
            total += item.sum_vos;
            var _item = {};
            var _vos_sentiment = item._id.vos_sentiment.toUpperCase();
            var pos = items.map(function(e) {
                return e.date;
            }).indexOf(item._id.date);
            if (pos == -1) {
                _item['date'] = item._id.date;
                _item['POSITIVE'] = 0;
                _item['NEUTRAL'] = 0;
                _item['NEGATIVE'] = 0;
                _item[_vos_sentiment] = item.sum_vos;
                items.push(_item);
            } else {
                _item = items[pos];
                if (_item[_vos_sentiment] != undefined) {
                    _item[_vos_sentiment] += item.sum_vos;
                } else {
                    _item[_vos_sentiment] = item.sum_vos;
                }
                items[pos] = _item;
            }
        });

        // sort by date desc        
        items.sort(function(a, b) {
            var _a = parseInt(a.date.split("-").join(""));
            var _b = parseInt(b.date.split("-").join(""));
            return _a - _b;
        });

        // attached colors 
        items.push(colors);

        if (total == 0) {
            items = [];
        }

        state.vos_sentiment_v2 = items
        // --- end dataset for bar-stack chart  
    },
    V2onVosObjectiveV1(state, payload) {
        // --- start dataset doughnut for chart
        // items = [{data:0,label:'label'}]
        var colors = [];
        colors['general'] = '#3241a6';
        colors['question'] = '#578e47';
        colors['enquiries'] = '#cf9a41';
        colors['admire'] = '#be4141';
        colors['complaint'] = '#7d3b98';

        var rows = state.vos_purpose.rows;
        var total = 0;
        var items = [];
        for (var key in colors) {
            items.push({ color: colors[key], data: 0, "label": key.toUpperCase() });
        }

        rows.forEach(function(item, index) {
            total += item.sum_vos;
        });

        rows.forEach(function(item, index) {
            var _color = "#e5e5e5";
            if (colors[item._id.vos_purpose] !== undefined) {
                _color = colors[item._id.vos_purpose];
            }

            var label = item._id.vos_purpose.toUpperCase();
            var _item = { "data": item.sum_vos, "label": label, color: _color };

            // sort by user defined - colors array
            var _index = 0;
            for (var key in colors) {
                if (key == item._id.vos_purpose) {
                    items[_index] = _item;
                }
                _index++;
            }
        });
        // check total
        if (total == 0) {
            items = [];
        }
        state.vos_objective_v1 = items
        // --- end dataset for doughnut chart
    },
    V2onVosObjectiveV2(state, payload) {
        // --- start dataset for stack chart
        // items = [{label1:0,label2:0,...,date:string}]
        var total = 0;
        var colors = [];
        colors['GENERAL'] = '#3241a6';
        colors['QUESTION'] = '#578e47';
        colors['ENQUIRIES'] = '#cf9a41';
        colors['ADMIRE'] = '#be4141';
        colors['COMPLAINT'] = '#7d3b98';

        var rows = state.vos_purpose_x_date.rows;
        var items = [];
        rows.forEach(function(item, index) {
            total += item.sum_vos;
            var _item = {};
            var _vos_purpose = item._id.vos_purpose.toUpperCase();
            var pos = items.map(function(e) {
                return e.date;
            }).indexOf(item._id.date);
            if (pos == -1) {
                _item['date'] = item._id.date;
                _item['GENERAL'] = 0;
                _item['QUESTION'] = 0;
                _item['ENQUIRIES'] = 0;
                _item['ADMIRE'] = 0;
                _item['COMPLAINT'] = 0;
                _item[_vos_purpose] = item.sum_vos;
                items.push(_item);
            } else {
                _item = items[pos];
                if (_item[_vos_purpose] != undefined) {
                    _item[_vos_purpose] += item.sum_vos;
                } else {
                    _item[_vos_purpose] = item.sum_vos;
                }
                items[pos] = _item;
            }
        });

        // sort by date desc        
        items.sort(function(a, b) {
            var _a = parseInt(a.date.split("-").join(""));
            var _b = parseInt(b.date.split("-").join(""));
            return _a - _b;
        });

        // attached colors 
        items.push(colors);

        if (total == 0) {
            items = [];
        }

        state.vos_objective_v2 = items
        // --- end dataset for stack chart
    },
    onEngagementOfSoutheastAsiaTable(state, payload) {
        var rows = state.vos_datasets;
        var vos_datatable = {
            headers: [
                { text: 'EV', value: "ev", align: 'left', sortable: false},
                { text: 'Date', value: "date", align: 'left', style: 'width:200px;', sortable: false },
                { text: 'Country', value: "location_source", align: 'left', sortable: false },
                { text: 'Name', value: "name", align: 'left', sortable: false },
                { text: 'Message', value: "message", align: 'left', sortable: false },
                { text: 'Channels', value: "channel", align: 'left', sortable: false },
                { text: 'Sentiment', value: "sentiment", align: 'left', sortable: false },
                { text: 'Like', value: "like", align: 'left', sortable: false },
                { text: 'Share', value: "share", align: 'left', sortable: false },
                { text: 'Comment', value: "comment", align: 'left', sortable: false }
            ],
            items: [{
                value: false,
                ev: '',
                name: '',
                message: '',
                like: '',
                share: '',
                comment: '',
                link: ''
            }],
            pagination: {
                sortBy: 'date',
                descending: true,
            },
            total: 0,
        };

        // build items
        var items = [];
        rows.forEach(function(item, index) {
            var _item = {
                value: false,
                ev: item.ev,
                date: item.date,
                location_source: item.location_source,
                name: item.name,
                message: textTruncate(item.message, 117),
                channel: item.channel,
                purpose: item.purpose,
                sentiment: item.sentiment,
                like: item.like,
                share: item.share,
                comment: item.comment,
                link: item.link
            }
            items.push(_item);
        });

        vos_datatable.items = items;
        vos_datatable.total = state.vos_total;
        //vos_datatable.vos_purpose = state.vos_purpose.sort(function(a, b) { return a.localeCompare(b) });
        //vos_datatable.vos_channels = state.vos_channels.sort(function(a, b) { return a.localeCompare(b) });
        //vos_datatable.vos_sentiment = state.vos_sentiment.sort(function(a, b) { return a.localeCompare(b) });
        state.vos_engagement_southasia_table = vos_datatable;
        // --- start dataset for v-data-table
    },
    onPostSocialCountryTopFive(state, payload) {
        // --- start dataset table for chart widget no 123
        let rows = state.vos_country_top_five_table;
        state.vos_country_top_five_table = rows;
    }
}

export default {
    state,
    getters,
    actions,
    mutations
}